<div class="container">
  <app-page-toolbar
    title="Voice2Voice Transcripts"
    icon="record_voice_over"
    (back)="backToDashboard()"
    backButtonLabel="Back"
  ></app-page-toolbar>
  <!-- Header -->
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title>Voice2Voice Transcripts</mat-card-title>
      <mat-card-subtitle
        >View and filter Nova Sonic voice-to-voice call
        transcripts</mat-card-subtitle
      >
    </mat-card-header>
  </mat-card>

  <!-- Filters -->
  <mat-card class="filter-card">
    <mat-card-header>
      <mat-card-title>Filters</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="filters-grid">
        <!-- Product Type Filter -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Product Type</mat-label>
          <mat-select
            [(ngModel)]="filters().productType"
            (selectionChange)="onFilterChange()"
          >
            <mat-option value="">All Product Types</mat-option>
            <!-- lets get all the products for the time being -->
            <!-- <mat-option *ngFor="let type of productTypes" [value]="type.value">
              {{ type.label }}
            </mat-option> -->
          </mat-select>
        </mat-form-field>

        <!-- Brand Filter -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Brand</mat-label>
          <mat-select
            [(ngModel)]="filters().brand"
            (selectionChange)="onFilterChange()"
          >
            <mat-option value="">All Brands</mat-option>
            <mat-option *ngFor="let brand of brands" [value]="brand.value">
              {{ brand.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Start Date Filter -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="pickerStart"
            [(ngModel)]="filters().startDate"
            (change)="onFilterChange()"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerStart"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>

        <!-- End Date Filter -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>End Date</mat-label>
          <input
            matInput
            [matDatepicker]="pickerEnd"
            [(ngModel)]="filters().endDate"
            (change)="onFilterChange()"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerEnd"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>

        <!-- Limit -->
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Results per page</mat-label>
          <mat-select
            [(ngModel)]="filters().limit"
            (selectionChange)="onFilterChange()"
          >
            <mat-option value="10">10</mat-option>
            <mat-option value="25">25</mat-option>
            <mat-option value="50">50</mat-option>
            <mat-option value="100">100</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Action Buttons -->
      <div class="filter-actions">
        <button
          mat-raised-button
          color="primary"
          (click)="applyFilters()"
          [disabled]="isLoading()"
        >
          <mat-icon *ngIf="!isLoading()">search</mat-icon>
          <mat-spinner diameter="20" *ngIf="isLoading()"></mat-spinner>
          {{ isLoading() ? 'Loading...' : 'Apply Filters' }}
        </button>
        <button
          mat-stroked-button
          (click)="clearFilters()"
          [disabled]="isLoading()"
        >
          <mat-icon>clear</mat-icon>
          Clear Filters
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- PO Tips -->
  <mat-card
    style="
      background-color: #eef2f7;
      border-left: 6px solid #1a73e8;
      margin-bottom: 24px;
      border-radius: 8px;
    "
  >
    <mat-card-content style="padding: 16px">
      <div style="display: flex; align-items: center; margin-bottom: 8px">
        <mat-icon style="color: #1a73e8; margin-right: 8px"
          >help_outline</mat-icon
        >
        <strong style="color: #1a73e8; font-size: 16px"
          >How Product Owners (POs) Can Use This Widget:</strong
        >
      </div>
      <ul
        style="
          margin: 0;
          padding-left: 20px;
          line-height: 1.6;
          color: #444;
          font-size: 14px;
        "
      >
        <li>
          <strong>Prevent Timeouts:</strong> If exporting massive date ranges
          (e.g. 1 month+), export in smaller chunks (like weekly increments) to
          keep requests fast.
        </li>
        <li>
          <strong>Maintain Data Compliance:</strong> Keep
          <code>Customer ID</code> and <code>Plan Number</code>
          deselected to produce completely clean, anonymous exports.
        </li>
        <li>
          <strong>Get Readable Reports:</strong> Use the
          <strong>"Export HTML Report"</strong> option to generate a standalone
          web report showcasing each call's transcript in structured,
          easy-to-read cards.
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <!-- Smart Export -->
  <mat-card class="export-card">
    <mat-card-header>
      <mat-card-title>Smart Export</mat-card-title>
      <mat-card-subtitle
        >Select a date range and columns to export</mat-card-subtitle
      >
    </mat-card-header>

    <mat-card-content>
      <div class="date-range">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="exportPickerStart"
            [(ngModel)]="exportStartDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="exportPickerStart"
          ></mat-datepicker-toggle>
          <mat-datepicker #exportPickerStart></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input
            matInput
            [matDatepicker]="exportPickerEnd"
            [(ngModel)]="exportEndDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="exportPickerEnd"
          ></mat-datepicker-toggle>
          <mat-datepicker #exportPickerEnd></mat-datepicker>
        </mat-form-field>
      </div>

      <h3>Select Columns</h3>
      <div class="column-grid">
        <div *ngFor="let col of exportColumns()" class="column-item">
          <mat-checkbox [(ngModel)]="col.selected">{{
            col.label
          }}</mat-checkbox>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions class="export-actions">
      <button
        mat-raised-button
        color="primary"
        [disabled]="isExporting()"
        (click)="exportData('csv')"
      >
        <mat-spinner diameter="20" *ngIf="isExporting()"></mat-spinner>
        <mat-icon *ngIf="!isExporting()">download</mat-icon>
        {{ isExporting() ? exportProgress() || 'Exporting...' : 'Export CSV' }}
      </button>
      <button
        mat-stroked-button
        color="accent"
        [disabled]="isExporting()"
        (click)="exportData('html')"
      >
        <mat-icon>description</mat-icon>
        Export HTML Report
      </button>
    </mat-card-actions>
  </mat-card>

  <!-- Error Card -->
  <mat-card class="error-card" *ngIf="errorMessage()">
    <mat-card-content>
      <div class="error-container">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <div class="error-content">
          <h3>Error</h3>
          <p>{{ errorMessage() }}</p>
          <button
            mat-stroked-button
            color="primary"
            (click)="errorMessage.set(null)"
          >
            <mat-icon>close</mat-icon>
            Dismiss
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Results -->
  <mat-card
    class="results-card"
    *ngIf="transcripts().length > 0 || isLoading()"
  >
    <mat-card-header>
      <mat-card-title>Results</mat-card-title>
      <mat-card-subtitle *ngIf="totalCount() > 0">
        Showing {{ transcripts().length }} of {{ totalCount() }} transcripts
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="table-container">
        <table mat-table [dataSource]="transcripts()" class="transcripts-table">
          <!-- Customer ID Column -->
          <ng-container matColumnDef="customerId">
            <th mat-header-cell *matHeaderCellDef>Customer ID</th>
            <td mat-cell *matCellDef="let element">
              <span
                class="cell-value"
                [matTooltip]="element.pk"
                matTooltipPosition="above"
              >
                {{ element.pk | slice: 0 : 12 }}...
              </span>
            </td>
          </ng-container>

          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date & Time</th>
            <td mat-cell *matCellDef="let element">
              {{ formatDate(element.sk) }}
            </td>
          </ng-container>

          <!-- Plan Number Column -->
          <ng-container matColumnDef="planNumber">
            <th mat-header-cell *matHeaderCellDef>Plan Number</th>
            <td mat-cell *matCellDef="let element">
              {{ element.planNumber || '—' }}
            </td>
          </ng-container>

          <!-- Product Type Column (NEW) -->
          <ng-container matColumnDef="productType">
            <th mat-header-cell *matHeaderCellDef>Product Type</th>
            <td mat-cell *matCellDef="let element">
              <span class="badge badge-info" *ngIf="element.productType">
                {{ formatProductType(element.productType) }}
              </span>
              <span *ngIf="!element.productType" class="empty-cell">—</span>
            </td>
          </ng-container>

          <!-- Brand Column (NEW) -->
          <ng-container matColumnDef="brand">
            <th mat-header-cell *matHeaderCellDef>Brand</th>
            <td mat-cell *matCellDef="let element">
              <span class="badge badge-success" *ngIf="element.brand">
                {{ element.brand }}
              </span>
              <span *ngIf="!element.brand" class="empty-cell">—</span>
            </td>
          </ng-container>

          <!-- Chat Duration Column -->
          <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef>Duration</th>
            <td mat-cell *matCellDef="let element">
              {{ formatDuration(element.chatDuration) }}
            </td>
          </ng-container>

          <!-- Message Count Column -->
          <ng-container matColumnDef="messageCount">
            <th mat-header-cell *matHeaderCellDef>Messages</th>
            <td mat-cell *matCellDef="let element">
              {{ element.messageHistory?.length || 0 }}
            </td>
          </ng-container>

          <!-- Rating column-->
          <ng-container matColumnDef="rating">
            <th mat-header-cell *matHeaderCellDef>Rating</th>
            <td mat-cell *matCellDef="let element">
              {{ element.rating || '—' }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                matTooltip="View Details"
                (click)="viewDetails(element)"
              >
                <mat-icon>visibility</mat-icon>
              </button>
              <button
                mat-icon-button
                matTooltip="Show voice → text fallback"
                (click)="viewFallbackTrace(element)"
              >
                <mat-icon>call_split</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
      </div>

      <!-- Loading Spinner -->
      <div class="loading-spinner" *ngIf="isLoading()">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading transcripts...</p>
      </div>

      <!-- Pagination -->
      <div
        class="pagination-container"
        *ngIf="!isLoading() && transcripts().length > 0"
      >
        <button
          mat-stroked-button
          (click)="loadPreviousPage()"
          [disabled]="!hasPreviousPage()"
          matTooltip="Load previous page"
        >
          <mat-icon>navigate_before</mat-icon>
          Previous
        </button>
        <span class="page-info">
          Page {{ currentPage() }} · {{ transcripts().length }} results
        </span>
        <button
          mat-stroked-button
          (click)="loadNextPage()"
          [disabled]="!hasNextPage()"
          matTooltip="Load next page"
        >
          Next
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- average user rating of V2V -->
  @if (transcripts().length > 0 || isLoading()) {
    <mat-card class="rating-summary-card">
      <mat-card-header>
        <mat-card-title>Average user rating of V2V experience</mat-card-title>
        <mat-card-subtitle
          >Based on feedback provided at the end of the experience; optional
          field
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div class="rating-summary-grid">
          <div class="rating-summary-item">
            <p>Average user rating</p>
            <strong>
              @if (averageUserRating() !== null) {
                {{ averageUserRating() }} / 5
              } @else {
                —
              }
            </strong>
          </div>
          <div class="rating-summary-item">
            <p>Number of ratings provided</p>
            <strong>
              {{ userRatingCount() || '-' }}
            </strong>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  <!-- Empty State -->
  <mat-card
    class="empty-state-card"
    *ngIf="!isLoading() && transcripts().length === 0 && hasSearched()"
  >
    <mat-card-content>
      <mat-icon class="empty-icon">search_off</mat-icon>
      <h2>No transcripts found</h2>
      <p>Try adjusting your filters or date range</p>
      <button mat-raised-button color="primary" (click)="clearFilters()">
        Clear Filters
      </button>
    </mat-card-content>
  </mat-card>

  <!-- Initial State -->
  <mat-card
    class="empty-state-card"
    *ngIf="!isLoading() && transcripts().length === 0 && !hasSearched()"
  >
    <mat-card-content>
      <mat-icon class="empty-icon">info</mat-icon>
      <h2>Start filtering transcripts</h2>
      <p>
        Select filters above and click "Apply Filters" to view voice-to-voice
        transcripts
      </p>
    </mat-card-content>
  </mat-card>

  <!-- Details Modal (Simple implementation) -->
  <mat-card class="details-modal" *ngIf="selectedTranscript()">
    <mat-card-header>
      <mat-card-title>Transcript Details</mat-card-title>
      <button mat-icon-button (click)="closeDetails()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <div class="detail-grid">
        <div class="detail-item">
          <span class="detail-label">Customer ID:</span>
          <span class="detail-value">{{ selectedTranscript()?.pk }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Date & Time:</span>
          <span class="detail-value">{{
            formatDate(selectedTranscript()?.sk || '')
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Plan Number:</span>
          <span class="detail-value">{{
            selectedTranscript()?.planNumber || '—'
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Product Type:</span>
          <span
            class="detail-value badge badge-info"
            *ngIf="selectedTranscript()?.productType"
          >
            {{ formatProductType(selectedTranscript()?.productType || '') }}
          </span>
          <span class="detail-value" *ngIf="!selectedTranscript()?.productType"
            >—</span
          >
        </div>
        <div class="detail-item">
          <span class="detail-label">Brand:</span>
          <span
            class="detail-value badge badge-success"
            *ngIf="selectedTranscript()?.brand"
          >
            {{ selectedTranscript()?.brand }}
          </span>
          <span class="detail-value" *ngIf="!selectedTranscript()?.brand"
            >—</span
          >
        </div>
        <div class="detail-item">
          <span class="detail-label">Duration:</span>
          <span class="detail-value">{{
            formatDuration(selectedTranscript()?.chatDuration || 0)
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Messages:</span>
          <span class="detail-value">{{
            selectedTranscript()?.messageHistory?.length || 0
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Connection ID:</span>
          <span class="detail-value">{{
            selectedTranscript()?.connectionId
          }}</span>
        </div>
      </div>

      <div
        class="message-history"
        *ngIf="
          selectedTranscript()?.messageHistory &&
          selectedTranscript()!.messageHistory.length > 0
        "
      >
        <h3>Message History</h3>
        <div class="messages">
          <div
            class="message"
            *ngFor="let msg of selectedTranscript()?.messageHistory"
          >
            <span class="message-timestamp" *ngIf="getMessageTimestamp(msg)"
              >[{{ getMessageTimestamp(msg) | date: 'shortTime' }}]</span
            >
            <span class="message-role" [ngClass]="msg.role"
              >{{ msg.role | titlecase }}:</span
            >
            <span class="message-content">{{ getMessageContent(msg) }}</span>
          </div>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button mat-stroked-button (click)="closeDetails()">Close</button>
    </mat-card-actions>
  </mat-card>

  <!-- Fallback Analytics Overview -->
  <app-fallback-analytics-widget></app-fallback-analytics-widget>
</div>
